<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <ShowTeam v-if="teamExist" :teamInfo="teamInfo" />
      <Verify
        v-else-if="teamRequests"
        :teamInfo="teamInfo"
        @reloadPage="getTeam()"
      />
      <AddTeam v-else @reloadPage="getTeam()" />
    </div>
  </div>
</template>
<script>
import TheSidemenu from "@/components/TheSidemenu";
import TheTopmenu from "@/components/TheTopmenu";
import ArefApi from "../../../libs/api.js";
import utils from "../../../libs/utils";
import AddTeam from "./components/AddTeam";
import ShowTeam from "./components/ShowTeam";
import Verify from "./components/Verify";

export default {
  name: "Team",
  created() {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
    this.getTeam();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    AddTeam,
    ShowTeam,
    Verify,
  },
  data() {
    return {
      teamExist: false,
      teamInfo: null,
      teamRequests: false,
    };
  },
  methods: {
    getTeam() {
      this.arefApi
        .getTeamUser()
        .then((resp) => {
          if (resp.data.length === 0) {
            this.teamRequests = false;
            this.teamExist = false;
            return;
          }
          this.teamRequests = resp.type === "offers";
          this.teamExist = resp.type === "team";
          this.teamInfo = resp.data;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
  },
};
</script>

